import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=54b61643&scoped=true&"
import script from "./QuestionCard.vue?vue&type=script&lang=js&"
export * from "./QuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=54b61643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b61643",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b61643')) {
      api.createRecord('54b61643', component.options)
    } else {
      api.reload('54b61643', component.options)
    }
    module.hot.accept("./QuestionCard.vue?vue&type=template&id=54b61643&scoped=true&", function () {
      api.rerender('54b61643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/space/components/QuestionCard.vue"
export default component.exports